import { cva } from "class-variance-authority";

export const registrationFeedbackSurveyBannerStyles = cva([
  "flex w-full items-start gap-3 bg-[#E8F4FC] px-4 py-4",
  "md:px-8",
]);

export const registrationFeedbackSurveyBannerTextStyles = cva([
  "m-0 font-[Poppins,sans-serif] text-sm font-normal leading-5 tracking-[0.25px] text-[#003049]",
  "md:text-base md:leading-6 md:tracking-[0.5px]",
]);
